import BaseObject from '../../../../../base/base_object';
import ServiceFactory from '../../../../service_factory';

export class DkStructuredLogging extends BaseObject {
  static CLASS = 'DkStructuredLogging';

  init(params = {}) {
    super.init(params);
    this.serviceFactory = params.serviceFactory || ServiceFactory.create();
  }

  realityCheckMessageSuccess(regulationData, sessionTime) {
    this._getLogger({
      event: 'RealityCheckMessage',
      currencyType: this.serviceFactory.currencyService().getCurrency(),
      netLoss: regulationData.TotalNetLoss / 100,
      loggedInTime: sessionTime,
      fullMessage: true,
    })
      .setTarget('Denmark-realityCheck')
      .info();
  }

  realityCheckMessageError(error, sessionTime) {
    this._getLogger({
      event: 'RealityCheckMessage',
      currencyType: this.serviceFactory.currencyService().getCurrency(),
      loggedInTime: sessionTime,
      fullMessage: false,
      errorDescription: error.ErrorDescription,
    })
      .setTarget('Denmark-realityCheck')
      .error();
  }

  _getLogger(eventData) {
    return this.serviceFactory.structuredLoggingService().getLogger(eventData);
  }
}
